import { render, staticRenderFns } from "./AddElementDrawer.vue?vue&type=template&id=15c08b0e&scoped=true&"
import script from "./AddElementDrawer.vue?vue&type=script&lang=js&"
export * from "./AddElementDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AddElementDrawer.vue?vue&type=style&index=0&id=15c08b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c08b0e",
  null
  
)

export default component.exports